import React, { useState, useEffect } from "react";
import BatteryIndicator from '../ZingNotifications/BatteryIndicator';
import { openAiSection } from "../../../utils/aiNavigation";
import { useHistory } from "react-router";
import { connect } from "react-redux";

import {
  deviceDetails,
  deviceMismatch,
  showModal,
  webSerialConnect,
} from "../../../redux/actions";
import { readBytes, sendBytes } from "../../ReusableComponents/ByteTransfer";

import renderImage from "../../../source/importImg";
import style from "./MainHeader.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import {
  connectSerialDevice,
  connectSerialDeviceInitial,
  connectSerialDeviceIntermediate,
  connectUSBDevice,
  openSerialReadComPort,
} from "../../WebSerialConnection/SerialUSBConnect";
import cacheAssets from "../../../utils/cacheAssets";
import { decrypt, generateBrowserFingerprint } from "../../Login/JWTverify";
import DialogModal from "../DialogModal/DialogModal";
import DeviceMissMatchPopupCom from "./DeviceMissMatchPopupCom";
import AiSelectModal from "../AiSelectModal/AiSelectModal";
import aiHeaderBtn from "../../../Assets/images/aiHeaderBtnFlat.svg";
import { Info } from '@material-ui/icons'

const importIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-upload"
    viewBox="0 0 16 16"
  >
    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
    <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
  </svg>
);

function MainHeader({
  webSerial,
  worker,
  webSerialConnect,
  title,
  helper,
  showBluetoothBtn,
  titlePosition,
  help_btnPosition,
  showImport = false,
  handleImport,
  goBack,
  isGoBack,
  showUserAccount,
  showAccountSetting,
  deviceMismatch,
  showFirmwareUpdateDialog,
  device,
  deviceDetail,
  DeselectedComponent,
  concept,
  isShowSleep = false,
  socketData,
  handelSleepIconClick = () => { },
  userIgnoredUpdates,
  isShowStopIcon = false,
  isStopIconActive = false,
  handelStopBytes = () => { },
  isShowAiSwipeBtn = false,
  swipeActive = 'AI',
  setSwipeActive = () => { },
  showAiBtn = false,
  handleAiClick,
  isShowEdit = false,
  handelOpenEditingPopUp = () => { },
  isShowLanguageIcon = false,
  handelOpenLanguagePopup = () => { },
  btns = ['AI', 'Custom'],
  swipeBtnStyles = { aiActive: {}, customActive: {}, wrapper: {}, aiBtn: {} },

  isShowCloud = false,
  handelCloudClick = () => { },
  isShowSearchBar = false,
  searchText = "",
  handelSearchChange = () => { },
  suggestions = [],
  handelClickSearchProject = () => { },
  handelSearchClear = () => { },
  filterProject = [],
}) {
  const history = useHistory();
  const hasLeftHeaderIcons =
    isShowStopIcon ||
    isShowLanguageIcon ||
    (isShowEdit && swipeActive === 'Custom');
  const location = window.location;
  const [showAiSelectModal, setShowAiSelectModal] = useState(false);
  const hasSideIcons = showAccountSetting || isShowSleep;
  const aiBtnRight = hasSideIcons ? "15.04%" : "10.04%";
  const aiBtnTooltipLeft = hasSideIcons ? "83%" : "88.3%";
  const onAiClick = handleAiClick || (() => setShowAiSelectModal(true));
  const [isHelp, setHelp] = useState(false);
  const [isDeviceMismatch, setIsDeviceMismatch] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showErrorMsg, setshowErrorMsg] = useState(false);
  const connectedDevice = sessionStorage.getItem("connectedDevice");
  const deviceVersion = sessionStorage.getItem("deviceVersion");

  let deviceName = "";
  switch (connectedDevice) {
    case "Hexapod":
      deviceName = "Crawl-e";
      break;
    default:
      deviceName = "Zing";
  }

  const handleLogout = () => {
    // Perform logout action here
    setShowPopup(false);
    history.push("/login");
    localStorage.removeItem("userJWT");
    localStorage.removeItem("atatus-user");
  };

  const handleClick = () => {
    const pcVersion = sessionStorage.getItem("deviceVersion");
    const connectedDevice = sessionStorage.getItem("connectedDevice");
    // if (connectedDevice == 'Ace' && pcVersion === '0.1.18') {
    //     history.push('/advanceSettingv0.1')
    // } else if (
    //     (connectedDevice == 'Ace' && pcVersion?.startsWith('1')) ||
    //     ['Roboki'].includes(connectedDevice)
    // ) {
    history.push("/advanceSettingv1.0");
    // } else {
    //     history.push('/advanceSettingZingv0.1')
    // }
  };

  const handleHelpBtn = () => {
    setHelp(!isHelp);
  };

  const requestConnection = async (e) => {
    if (!webSerial.isConnected) {
      let res = await connectSerialDeviceIntermediate(
        { isAutomatic: false },
        worker,
        socketData,
      );
      if (res !== undefined) {
        if (res.matchedObj_with_Version?.firmwareUnsupported) {
          // Unsupported firmware must never be accepted as the connected
          // device — show the firmware update dialog directly instead of
          // the generic device-mismatch popup.
          const mismatchedDevice = res.matchedObj_with_Version;
          showFirmwareUpdateDialog({
            currentVersion: mismatchedDevice.currentVersion,
            latestVersion: mismatchedDevice.minFirmware,
            deviceName: mismatchedDevice.id,
            firmwareCheck: { mandatory: true },
          });
        } else if (!res.isPortOpen) {
          deviceMismatch({
            deviceMismatched: res.matchedObj_with_Version,
            isMemoryPresent: res.isMemoryPresent,
            isArmError: res.isArmError,
            is2In1Sensor: res.is2In1Sensor,
            plodeNativeData: {
              ...device.plodeNativeData,
              mountPoint: res.mountPoint,
            },
          });
          setIsDeviceMismatch(true);
        } else {
          setIsDeviceMismatch(false);
          deviceMismatch({
            deviceMismatched: {},
            isMemoryPresent: res.isMemoryPresent,
            isArmError: res.isArmError,
            is2In1Sensor: res.is2In1Sensor,
            plodeNativeData: {
              ...device.plodeNativeData,
              mountPoint: res.mountPoint,
            },
          });
        }
      }
      // port = port['port']

      // if (e.data.type == 'connected' && e.data.value) {
      if (res) webSerialConnect({ port: res.port });
      else setshowErrorMsg(true);
    }
  };
  //for mismatch of device while connecting
  const handleDevice = async (option) => {
    if (option === "no") {
      let port = webSerial.port;
      //is this needed??
      // await openSerialReadComPort(port,worker)
    } else if (device.deviceMismatched?.firmwareUnsupported) {
      // Unsupported firmware must never be accepted as the connected
      // device — show the firmware update dialog after the mismatch is
      // acknowledged, instead of accepting the connection.
      const mismatchedDevice = device.deviceMismatched;
      showFirmwareUpdateDialog({
        currentVersion: mismatchedDevice.currentVersion,
        latestVersion: mismatchedDevice.minFirmware,
        deviceName: mismatchedDevice.id,
        firmwareCheck: { mandatory: true },
      });
    } else {
      shouldErase();
      history.push("/Selection");
      let mismatchedDevice = device.deviceMismatched;
      console.log(mismatchedDevice);
      sessionStorage.setItem("connectedDevice", mismatchedDevice.id);
      // if (
      //     mismatchedDevice.id === 'Ace' ||
      //     mismatchedDevice.id === 'Hexapod'
      // ) {
      sessionStorage.setItem("deviceVersion", mismatchedDevice.version);
      if (webSerial.isConnected)
        sessionStorage.setItem("isDeviceConnected", true);
      deviceDetail({
        connectedDevice: mismatchedDevice.id,
        deviceVersion: mismatchedDevice.version,
      });
      // } else {
      //     sessionStorage.setItem('zingVersion', mismatchedDevice.version)
      //     deviceDetail({
      //         connectedDevice: mismatchedDevice.id,
      //         zingVersion: mismatchedDevice.version,
      //         deviceVersion: '0.0.0',
      //     })
      // }
    }
    setIsDeviceMismatch(false);
    deviceMismatch({ deviceMismatched: {} });
  };
  //when device is disconnect set the mismatch empty
  useEffect(() => {
    if (sessionStorage.getItem("isDeviceConnected") == "false") {
      setIsDeviceMismatch(false);
      deviceMismatch({ deviceMismatched: {} });
    }
  }, [webSerial.isConnected]);

  const shouldErase = () => {
    let programMode = sessionStorage.programMode;
    let connectedDevice = sessionStorage.connectedDevice;
    let version = sessionStorage.deviceVersion;
    let recoveryData = JSON.parse(localStorage.getItem("recoveryData"));
    if (
      localStorage.getItem("recoveryData") !== null &&
      programMode in recoveryData &&
      connectedDevice in recoveryData[programMode] &&
      version in recoveryData[programMode][connectedDevice]
    ) {
      if (Object.keys(recoveryData).length === 1) {
        if (Object.keys(recoveryData[programMode]).length === 1) {
          if (
            Object.keys(recoveryData[programMode][connectedDevice]).length === 1
          ) {
            localStorage.removeItem("recoveryData");
          } else {
            delete recoveryData[programMode][connectedDevice][version];
            localStorage.setItem("recoveryData", JSON.stringify(recoveryData));
          }
        } else {
          if (
            Object.keys(recoveryData[programMode][connectedDevice]).length === 1
          ) {
            delete recoveryData[programMode][connectedDevice];
          } else {
            delete recoveryData[programMode][connectedDevice][version];
          }
          localStorage.setItem("recoveryData", JSON.stringify(recoveryData));
        }
      } else {
        if (Object.keys(recoveryData[programMode]).length === 1) {
          if (
            Object.keys(recoveryData[programMode][connectedDevice]).length === 1
          ) {
            delete recoveryData[programMode];
          } else {
            delete recoveryData[programMode][connectedDevice][version];
          }
          localStorage.setItem("recoveryData", JSON.stringify(recoveryData));
        } else {
          if (
            Object.keys(recoveryData[programMode][connectedDevice]).length === 1
          ) {
            delete recoveryData[programMode][connectedDevice];
          } else {
            delete recoveryData[programMode][connectedDevice][version];
          }
          localStorage.setItem("recoveryData", JSON.stringify(recoveryData));
        }
      }
    }
    sessionStorage.removeItem("programEnd");
    sessionStorage.setItem("pip", false);
    sessionStorage.setItem("name", "null");
    sessionStorage.removeItem("Index");
    sessionStorage.setItem("shield", "false");
    sessionStorage.setItem("peeCeeATR", "false");
    sessionStorage.setItem("arm_shield", "false");
    sessionStorage.removeItem("PET");
    sessionStorage.removeItem("EndSwitch");
    concept.Index = [];
    // window.location.reload(false)
    DeselectedComponent({
      Four_in_one_sensor: {
        isDistanceSensors: false,
        isGestureSensor: false,
        isLightSensor: false,
        isColorSensor: false,
      },
      isFour_in_one_sensor: false,

      isMic: false,
      isTemperature: false,

      // input
      isTouchZero: false,
      isTouchOne: false,
      isTouchTwo: false,

      // output
      isTouchZeroOutput: false,
      isTouchOneOutput: false,
      isTouchTwoOutput: false,

      isLeftEye: false,
      isRightEye: false,
      isbuzzer: false,

      isSmileOne: false,
      isSmileTwo: false,
      isSmileThree: false,
      isSmileFour: false,
    });
  };
  //handle error in connection
  const handleError = async () => {
    setshowErrorMsg(false);
    window.location.reload();
  };
  useEffect(() => {
    if (device && device.deviceMismatched) {
      let deviceD = Object.keys(device.deviceMismatched);
      if (deviceD.length > 1) {
        if (isDeviceMismatch == false) {
          setIsDeviceMismatch(true);
        }
      }
    }
  }, [device.deviceMismatched]);

  const [googleUserData, setGoogleUserData] = useState({});

  const getDataFromLocalStorage = () => {
    return new Promise((resolve, reject) => {
      let userAccount = localStorage.getItem("userJWT");

      if (userAccount) {
        resolve(userAccount ?? null);
      }
    });
  };

  const swipeBtnClick = () => {
    if (swipeActive === btns[1]) {
      setSwipeActive(btns[0])
    } else {
      setSwipeActive(btns[1])
    }
  }

  useEffect(async () => {
    const visitorId = await generateBrowserFingerprint();
    const userJWT = await getDataFromLocalStorage();
    if (!userJWT) return;
    const verify = await decrypt(userJWT, visitorId);
    if (verify) {
      const userData = {
        userAccount_email: verify.email,
        userAccount_name: verify.name,
        userAccount_Img: verify.image,
      };
      setGoogleUserData(userData);
    }
  }, []);

  useEffect(() => {
    let assetsToBeCached = [
      renderImage("backBtn"),
      renderImage("clos"),
      renderImage("helpBtnInActive"),
      renderImage("UsbOn"),
      renderImage("UsbOff"),
    ];
    cacheAssets(assetsToBeCached);
  }, []);

  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <>
      <DialogModal
        mismatchShow={isDeviceMismatch}
        text={<DeviceMissMatchPopupCom />}
        showCloseBtn={true}
        handleDialogModalClose={() => setIsDeviceMismatch(false)}
        optionsToSelect={[
          {
            text: 'YES',
            do: () => handleDevice('yes'),
          },
          // {
          //     text: 'NO',
          //     do: () => handleDevice('no'),
          // },
        ]}
      />
      {/* Old memory-card dialog for Zing: replaced by the firmware SD-card
          notification (ZingNotificationHost). */}
      {/*
      <DialogModal
        mismatchShow={
          connectedDevice == 'Humanoid' &&
          parseInt(deviceVersion?.split('.')?.[0] || '0') >= 2 &&
          webSerial.isConnected &&
          !isDeviceMismatch &&
          !device.isMemoryPresent
        }
        text={
          !device.isMemoryPresent
            ? `There is no memory card inserted in ${deviceName}. \nkindly insert one to use the application further.`
            : ''
        }
        showCloseBtn={false}
        optionsToSelect={[
          {
            text: 'YES',
            do: () => history.push('/kitSelection'),
          },
        ]}
      />
      */}
      <DialogModal
        showError={showErrorMsg}
        text={
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <p
              style={{
                transform: 'translateY(20%)',
                fontSize: '2.5vh',
              }}
            >
              Error in connecting the device!
            </p>
            <p
              style={{
                transform: 'translateY(20%)',
                fontSize: '2vh',
              }}
            >
              Please disconnect the device and try connecting
              again.
            </p>
          </div>
        }
        showCloseBtn={true}
        handleDialogModalClose={() => setshowErrorMsg(false)}
        optionsToSelect={[
          {
            text: 'OK',
            do: handleError,
          },
        ]}
      />
      <div className={style.container}>
        <div>
          {isGoBack || goBack ? (
            //to prevent user from going back in manual selection- location.pathname=='/biboxSelection'
            <img
              className={
                webSerial.isConnected &&
                  (location.pathname == '/Selection' ||
                    location.pathname == '/selection' ||
                    location.pathname == '/biboxSelection')
                  ? `${style.connected_back_btn}`
                  : `${style.back_btn}`
              }
              src={renderImage('backBtn')}
              onClick={async () => {
                if (goBack) {
                  goBack()
                } else history.goBack()
              }}
            ></img>
          ) : null}
        </div>
        <div>
          <p
            className={style.title}
            style={
              titlePosition === 'center' ? { left: '43%' } : null
            }
          >
            {title}
          </p>
        </div>

        {/* --------- swipe button ----------------------------- */}

        {isShowAiSwipeBtn && (
          <div className={style.swipeBtnDiv}>
            <div
              className={style.wrapper}
              onClick={() => {
                swipeBtnClick()
              }}
              style={{ ...swipeBtnStyles.wrapper }}
            >
              <div
                className={`${style.slider} ${swipeActive === btns[0]
                  ? style.aiActive
                  : style.customActive
                  }`}
                style={
                  swipeActive === btns[0]
                    ? { ...swipeBtnStyles.aiActive }
                    : { ...swipeBtnStyles.customActive }
                }
              />

              <div
                className={`${style.btn} ${style.aiBtn} ${swipeActive === btns[0]
                  ? style.activeText
                  : ''
                  }`}
                style={{ ...swipeBtnStyles.aiBtn }}
              >
                {btns[0]}
                {/* AI */}
              </div>

              <div
                className={`${style.btn} ${style.customBtn} ${swipeActive === btns[1] //'Custom'
                  ? style.activeText
                  : ''
                  }`}
              >
                {btns[1]}
                {/* Custom */}
              </div>
            </div>
          </div>
        )}
        {isShowSearchBar && (
          <div className={style.help_Body}>
            {/* USER PROFILE IMAGE */}
            <div className="header_button">
              <div className={style.searchInput}>
                <input
                  type="text"
                  name="search"
                  value={searchText}
                  onChange={(e) => handelSearchChange(e)}
                />
                {filterProject.length > 0 ? (
                  <div
                    className={style.binIcon}
                    onClick={() => handelSearchClear()}
                  >
                    <img
                      src="https://cdn-icons-png.flaticon.com/128/2976/2976286.png"
                      alt="bin"
                    />
                  </div>
                ) : (
                  <div className={style.searchIcon}>
                    <img src={renderImage("searchIcon")} alt="search" />
                  </div>
                )}
                {suggestions.length > 0 && (
                  <ul className={style.suggestions}>
                    {suggestions.map((suggestion, index) => (
                      <li
                        key={index}
                        onClick={() =>
                          handelClickSearchProject(suggestion, index)
                        }
                      >
                        <img
                          width={"24px"}
                          src={suggestion.image}
                          alt={suggestion.name}
                        />

                        <span className={style.suggestion_name}>
                          {suggestion.name}
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
        )}

        {showImport && (
          <div>
            <label className={style.importBtn}>
              <FontAwesomeIcon icon={faUpload} />
              <input
                type="file"
                style={{ display: 'none' }}
                accept=".ag"
                onChange={(evt) => {
                  handleImport(evt)
                }}
              ></input>
            </label>
          </div>
        )}

        {/* ---------------- pack byte send for zing and hexapod ----------- */}
        {isShowStopIcon && (
          <div style={{ zIndex: 1, width: '0' }}>
            {/* USER PROFILE IMAGE */}
            <div className="header_button">
              <img
                style={{ right: '13.5%' }}
                className={style.userAccount_settingBtn}
                src={isStopIconActive ? renderImage('stopActionIconActive') : renderImage('stopActionIcon')}
                onClick={() => handelStopBytes()}
              />
              <span
                className="tooltiptext"
                style={{
                  left: '85.1%',
                  top: '15vh',
                  height: '36px',
                }}
              >
                {' '}
                <p>Stop action</p>
              </span>
            </div>
          </div>
        )}
        {isShowLanguageIcon && (
          <div className={style.help_Body}>
            {/* USER PROFILE IMAGE */}
            <div className="header_button">
              <img
                style={{ right: '13.5%', top: '4%' }}
                className={style.userAccount_settingBtn}
                src={renderImage('languageIcon')}
                onClick={handelOpenLanguagePopup}
              />
              <span
                className="tooltiptext"
                style={{
                  left: '84.3%',
                  top: '16vh',
                  height: '36px',
                }}
              >
                {' '}
                <p>Language</p>
              </span>
            </div>
          </div>
        )}

        {isShowEdit && swipeActive === 'Custom' && (
          <div className={style.help_Body}>
            {/* USER PROFILE IMAGE */}
            <div className="header_button">
              <img
                style={{ right: '19%', top: '4%' }}
                className={style.userAccount_settingBtn}
                src={renderImage('editingIcon')}
                onClick={() => handelOpenEditingPopUp()}
              />
              <span
                className="tooltiptext"
                style={{
                  left: '78.8%',
                  top: '16vh',
                  height: '36px',
                }}
              >
                {' '}
                <p>Editing</p>
              </span>
            </div>
          </div>
        )}
        <div>
          {isHelp == false && helper ? (
            <div
              className="header_button"
            // style={{ position: 'relative' }}
            >
              <img
                className={style.help_btn}
                style={
                  help_btnPosition === 'right'
                    ? { right: '4%', ...(showAccountSetting && { top: '3.4%' }) }
                    : hasLeftHeaderIcons
                      ? { right: '8%' }
                      : null
                }
                src={renderImage('helpBtnInActive')}
                onClick={handleHelpBtn}
              ></img>
              <span
                className="tooltiptext"
                style={
                  help_btnPosition === 'right'
                    ? {
                      left: '94%',
                      top: 'calc(5vw + 26px)',
                      height: '36px',
                    }
                    : {
                      left: hasLeftHeaderIcons ? '90%' : '92%',
                      top: '16vh',
                      height: '36px',
                    }
                }
              >
                {' '}
                <p>Help</p>
              </span>
            </div>
          ) : (
            <div className={style.help_slider}>{helper}</div>
          )}

          {isHelp ? (
            <div>
              <img
                className={style.cross}
                src={renderImage("clos")}
                onClick={handleHelpBtn}
              ></img>
            </div>
          ) : null}
        </div>

        {showUserAccount && Object.keys(googleUserData).length ? (
          <div className={style.help_Body}>
            {/* USER PROFILE IMAGE */}
            <img
              className={style.userAccount_Btn}
              style={{
                display: imageError ? "none" : "block",
              }}
              src={googleUserData.userAccount_Img}
              onClick={() => setShowPopup(!showPopup)}
            />

            {showPopup && (
              <div className={style.popupCard}>
                <div
                  style={{
                    width: "310px",
                    height: "150px",
                    background: "#FFFFFF",
                    borderRadius: "32px 32px 0px 0px ",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                    columnGap: "4%",
                  }}
                >
                  <div>
                    <img
                      style={{
                        width: "55px",
                        borderRadius: "29px",
                        display: imageError ? "none" : "block",
                      }}
                      src={googleUserData.userAccount_Img}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <p>{googleUserData.userAccount_name}</p>
                    <p
                      style={{
                        marginTop: "-10px",
                        color: "grey",
                      }}
                    >
                      {" "}
                      {googleUserData.userAccount_email}
                    </p>
                  </div>
                </div>

                <div
                  style={{
                    marginTop: "7px",
                    width: "310px",
                    height: "123px",
                    background: "#FFFFFF",
                    // border: '2px solid blue',
                    borderRadius: "0px 0px 32px 32px ",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <button onClick={handleLogout}>
                    {/* {'[->'} */}
                    Sign out Your Account
                  </button>
                </div>
              </div>
            )}

            <span className={style.tooltiptext}>
              <p style={{ color: " #E4E5E4" }}>Google Account</p>
              <p>{googleUserData.userAccount_name}</p>
              <p> {googleUserData.userAccount_email}</p>
            </span>
          </div>
        ) : null}
        {isShowCloud && (
          <div className={style.help_Body}>
            {/* USER PROFILE IMAGE */}
            <div className="header_button">
              <img
                style={{ right: "4%" }}
                className={style.userAccount_settingBtn}
                src={renderImage("zingSleepIcon")}
                onClick={() => handelSleepIconClick()}
              />
              <span
                className="tooltiptext"
                style={{
                  left: "82.3%",
                  top: "16vh",
                  height: "36px",
                }}
              >
                {" "}
                <p>Cloud</p>
              </span>
            </div>
          </div>
        )}

        {/* ---------------- pack byte send for zing and hexapod ----------- */}
        {isShowSleep && (
          <div className={style.help_Body}>
            {/* USER PROFILE IMAGE */}
            <div className="header_button">
              <img
                style={{ right: showAiBtn ? "20.5%" : "15.5%" }}
                className={style.userAccount_settingBtn}
                src={renderImage("zingSleepIcon")}
                onClick={() => handelSleepIconClick()}
              />
              <span
                className="tooltiptext"
                style={{
                  left: showAiBtn ? "77.5%" : "82.3%",
                  top: "calc(5vw + 26px)",
                  height: "36px",
                }}
              >
                {" "}
                <p>Sleep</p>
              </span>
            </div>
          </div>
        )}

        <AiSelectModal
          show={showAiSelectModal}
          onClose={() => setShowAiSelectModal(false)}
          onSelect={() => {
            setShowAiSelectModal(false);
            openAiSection(history);
          }}
        />

        {showAiBtn && (
          <div className={style.help_Body}>
            <div className="header_button">
              <img
                className={style.userAccount_settingBtn}
                style={{
                  right: aiBtnRight,
                  zIndex: 10000,
                  width: "4%",
                  transform: "translateY(-11%) scale(0.775)",
                  transformOrigin: "center",
                  borderRadius: "50%",
                  boxShadow: "0 5px 8px rgba(91, 89, 214, 0.35)",
                }}
                src={aiHeaderBtn}
                alt="AI"
                onClick={onAiClick}
              />
              <span
                className="tooltiptext"
                style={{
                  left: aiBtnTooltipLeft,
                  top: "calc(5vw + 26px)",
                  height: "36px",
                  alignItems: "center",
                }}
              >
                <p>AI</p>
              </span>
            </div>
          </div>
        )}

        {showAccountSetting && (
          <div className={style.help_Body}>
            {/* USER PROFILE IMAGE wrapped in a relative container so badge anchors to it */}
            <div className="header_button">
              <div className={style.settingBtnWrapper}>
                <img
                  className={style.userAccount_settingBtn}
                  src={renderImage("activeAdvanceSetting")}
                  onClick={handleClick}
                />
                {/* Orange notification badge — same style as AdvanceSetting cards */}
                {(!socketData?.isAgentConnected ||
                  userIgnoredUpdates?.ignoredAssetUpdate ||
                  userIgnoredUpdates?.ignoredFirmwareUpdate) && (
                    <div
                      className={style.settingNotificationBadge}
                      onClick={handleClick}
                      title="Updates available in Advanced Settings"
                    >
                      <Info style={{ color: '#fff', fontSize: 'inherit' }} />
                    </div>
                  )}
              </div>
              <span
                className="tooltiptext"
                style={{
                  left: "88.5%",
                  top: "calc(5vw + 26px)",
                  height: "36px",
                }}
              >
                {" "}
                <p>Setting</p>
              </span>
            </div>
          </div>
        )}

        {showBluetoothBtn && (
          <div className="web_button" style={{ position: "unset" }}>
            <img
              className={style.bluetooth_Btn}
              src={
                webSerial.isConnected
                  ? renderImage("UsbOn")
                  : renderImage("UsbOff")
              }
              onClick={requestConnection}
            ></img>
            {/* Same box as the (absolutely positioned) button image so the
                battery knob lines up with it */}
            <span
              style={{
                position: "absolute",
                width: "6%",
                aspectRatio: "144 / 80",
                top: "4%",
                right: "0.1%",
                pointerEvents: "none",
              }}
            >
              <BatteryIndicator />
            </span>
            <span
              className="tooltiptext"
              style={{
                left: "96%",
                top: "17vh",
                height: "59px",
              }}
            >
              {" "}
              <p>
                Device <br />
                connectivity
              </p>
            </span>
          </div>
        )}
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return state;
};
const mapDispatchToProps = (dispatch) => {
  return {
    webSerialConnect: (data) => {
      dispatch(webSerialConnect(data));
    },
    showModal: (data) => {
      dispatch(showModal(data));
    },
    showFirmwareUpdateDialog: (payload) => {
      dispatch({ type: 'SHOW_FIRMWARE_UPDATE_DIALOG', payload });
    },
    deviceMismatch: (data) => {
      dispatch(deviceMismatch(data));
    },
    deviceDetail: (data) => {
      dispatch(deviceDetails(data));
    },
    DeselectedComponent: (data) => {
      dispatch({ type: "INTERNAL_ACCESSORIES", payload: data });
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MainHeader);
